import { DEFAULT_LOCALE, LOCALES, LOCALE_STORAGE_KEY } from "./config";

/** Attribute that hides <body> (globals.css) until I18nProvider has swapped the catalog in. */
export const LOCALE_PENDING_ATTRIBUTE = "data-locale-pending";

/**
 * Inline <head> script, run before first paint.
 *
 * Every page is prerendered in Thai, so a viewer who picked another language
 * would see Thai until the bundle hydrates and loads their catalog. This sets
 * <html lang> straight away and hides the page for that short window; the
 * timeout shows it anyway if the bundle never gets that far.
 */
export const LOCALE_INIT_SCRIPT = `(function(){try{var l=localStorage.getItem(${JSON.stringify(
	LOCALE_STORAGE_KEY,
)});if(l&&l!==${JSON.stringify(DEFAULT_LOCALE)}&&${JSON.stringify(
	LOCALES,
)}.indexOf(l)>-1){var d=document.documentElement;d.lang=l;d.setAttribute(${JSON.stringify(
	LOCALE_PENDING_ATTRIBUTE,
)},"");setTimeout(function(){d.removeAttribute(${JSON.stringify(
	LOCALE_PENDING_ATTRIBUTE,
)})},4000)}}catch(e){}})();`;
